var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.icon)?[_c('span',[_c('img',{attrs:{"src":_vm.icon}})])]:[_c('v-icon',[_vm._v(_vm._s(_vm.mdi))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }